import {
  Panel,
  SPACING_8,
  SpacingVertical,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import UpdateFrequency from './UpdateFrequency'

const BoxContentUpdates = () => {
  const intl = useIntl()

  return (
    <>
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({
          id: 'Load.ContentsSouces.UpdateDataCollect'
        })}
      </Title>
      <SpacingVertical variant={SPACING_8} />
      <Panel>
        <UpdateFrequency />
      </Panel>
    </>
  )
}

export default BoxContentUpdates
